import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ContactInfoRow } from './../../../../../molecules';
import { useL10n } from '@uplift/hooks';
import { Business, PhoneInTalkOutlined } from '@mui/icons-material';
import { Address, State } from '@uplift/api';
import { useMemo } from 'react';
import { PatientAddress } from '../AddressAccordion/PatientAddress.component';
import { UserContact } from '@uplift/types';

type AddressDisplay = {
  address?: never;
  state?: never;
  county?: never;
} | {
  address: Address | undefined;
  state: State | undefined;
  county?: string;
};

export type PatientContactInformationProps = {
  contacts: UserContact[];
  boldText?: boolean;
} & AddressDisplay;


export const PatientContactInformation: React.VFC<PatientContactInformationProps> = ({ address, state, ...props }) => {
  const { classes } = useStyles();
  const l10n = useL10n();

  const addressDisplay = useMemo(() => {
    if (address && state) {
      return (
        <Box display="flex">
          <Box mr={1}>
            <Business color="secondary" fontSize="small" />
          </Box>
          <PatientAddress address={address} state={state} />
        </Box>
      );
    }

    return null;
  }, [ address, state ]);

  return (
    <Box display="flex" flexDirection="column" gap="0.5rem">
      {props.contacts.map(c => (
        <Box key={c.id}>
          <ContactInfoRow
            secondary={l10n.resources.contacts.labelByName[c.name] ?? c.name}
            icon={PhoneInTalkOutlined}
            primary={c.value}
            text={c.value}
            type="phone"
            classes={{
              primary: props.boldText ? classes.boldText : undefined,
            }}
          />
        </Box>
      ))}
      {addressDisplay}
    </Box>
  );
};

const useStyles = makeStyles()({
  boldText: {
    fontWeight: 500,
  }
});
